import { gql } from '@apollo/client';

export default gql`
  mutation editTemplate(
    $id: ID!
    $name: String!
    $templateFields: [TemplateFieldInput!]!
    $periodNumber: Int
    $periodCycle: String
  ) {
    editTemplate(
      input: {
        id: $id
        name: $name
        templateFields: $templateFields
        periodNumber: $periodNumber
        periodCycle: $periodCycle
      }
    ) {
      template {
        id
      }
    }
  }
`;
